module.exports = __webpack_public_path__ + "static/banner2-7c47221e093de622273ba9b00e4bbf96.png";